import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "top",
      "label-width": "100px",
      size: "mini"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "架构编码",
      prop: "n02StrucCode"
    }
  }, [_c("cpsc-select", {
    attrs: {
      filterable: "",
      placeholder: "请选择"
    },
    on: {
      change: _vm.changeStrucCode
    },
    model: {
      value: _vm.form.n02StrucCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n02StrucCode", $$v);
      },
      expression: "form.n02StrucCode"
    }
  }, _vm._l(_vm.strucList, function (item) {
    return _c("el-option", {
      key: item.l01Id,
      attrs: {
        label: "".concat(item.l01StrucCode, "(").concat(item.l01Name, ")"),
        value: item.l01StrucCode
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "风险级别",
      prop: "n02RiskLevel"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.n02RiskLevel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n02RiskLevel", $$v);
      },
      expression: "form.n02RiskLevel"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "A"
    }
  }), _c("el-radio-button", {
    attrs: {
      label: "B"
    }
  }), _c("el-radio-button", {
    attrs: {
      label: "C"
    }
  }), _c("el-radio-button", {
    attrs: {
      label: "D"
    }
  })], 1)], 1)], 1)], 1), !_vm.isStruc ? _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "授权合伙人",
      prop: "partners"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var data = _ref.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.partners,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "partners", $$v);
      },
      expression: "form.partners"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "授权经理",
      prop: "managers"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var data = _ref2.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.managers,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "managers", $$v);
      },
      expression: "form.managers"
    }
  })], 1)], 1)], 1) : _vm._e(), !_vm.isStruc ? _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "授权查询人员"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var data = _ref3.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.viewers,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "viewers", $$v);
      },
      expression: "form.viewers"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "授权维护人员",
      prop: "maintainer"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var data = _ref4.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.maintainer,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "maintainer", $$v);
      },
      expression: "form.maintainer"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.isStruc ? _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "函证中心管理员",
      prop: "admin"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var data = _ref5.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.admin,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "admin", $$v);
      },
      expression: "form.admin"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "发函操作员",
      prop: "sender"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var data = _ref6.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.sender,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sender", $$v);
      },
      expression: "form.sender"
    }
  })], 1)], 1)], 1) : _vm._e(), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_vm.isStruc ? _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "回函操作员",
      prop: "replyPerson"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var data = _ref7.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.replyPerson,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "replyPerson", $$v);
      },
      expression: "form.replyPerson"
    }
  })], 1)], 1) : _vm._e(), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "质控级次",
      prop: "n02Qclevel"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.n02Qclevel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n02Qclevel", $$v);
      },
      expression: "form.n02Qclevel"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("三级审批")]), _c("el-radio-button", {
    attrs: {
      disabled: _vm.isStruc,
      label: "4"
    }
  }, [_vm._v("四级审批")]), _c("el-radio-button", {
    attrs: {
      disabled: _vm.isStruc,
      label: "5"
    }
  }, [_vm._v("五级审批")])], 1)], 1)], 1)], 1), !_vm.isStruc ? _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_vm.form.n02Qclevel == 4 || _vm.form.n02Qclevel == 5 ? _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      prop: "IQC",
      label: "授权独立质控人"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var data = _ref8.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.IQC,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "IQC", $$v);
      },
      expression: "form.IQC"
    }
  })], 1)], 1) : _vm._e(), _vm.form.n02Qclevel == 5 ? _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      prop: "IQCP",
      label: "授权独立质控合伙人"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var data = _ref9.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              label: item.name,
              value: item.id
            }
          });
        });
      }
    }], null, false, 1330368295),
    model: {
      value: _vm.form.IQCP,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "IQCP", $$v);
      },
      expression: "form.IQCP"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "text",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]), !_vm.onlyReady ? _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };